import React, { useState, useEffect, useRef } from "react";
import TheoryContentEditor from "../TheoryContentEditor";
import {
  parseTheoryContent,
  serializeTheoryBlocks,
  createEmptyBlock,
  BLOCK_TYPES,
} from "../../../../utils/theoryContentUtils";

export default function EditTheoryTopic({ formData, setFormData }) {
  const [blocks, setBlocks] = useState([]);
  const initializedRef = useRef(false);

  // Initialize blocks from existing theoryContent on first render
  useEffect(() => {
    if (
      !initializedRef.current &&
      formData &&
      formData.theoryContent &&
      formData.theoryContent.length > 0
    ) {
      const existingContent = formData.theoryContent.filter(
        (c) => c && c.trim()
      );
      if (existingContent.length > 0) {
        setBlocks(parseTheoryContent(existingContent));
      } else {
        setBlocks([createEmptyBlock(BLOCK_TYPES.PARAGRAPH)]);
      }
      initializedRef.current = true;
    }
  }, [formData]);

  // Sync blocks back to formData.theoryContent whenever blocks change
  useEffect(() => {
    if (!initializedRef.current) return;
    
    const serialized = serializeTheoryBlocks(blocks);
    setFormData((prev) => ({
      ...prev,
      theoryContent: serialized.length > 0 ? serialized : [""],
    }));
  }, [blocks, setFormData]);

  if (!formData || !formData.theoryContent) {
    return null;
  }

  return <TheoryContentEditor blocks={blocks} setBlocks={setBlocks} />;
}
